export const declarationDataSelector = (state) => state.SignatureData;
